<template lang="pug">
div
  h3.page-title {{$route.meta.title}}
  el-card
    template(slot="header")
      div(v-if="$route.meta.topConfig")
        el-row
          common-search-filter(ref="searchFilter" :filters="searchFilters")
        el-row
          component(v-for="(op, index) of topOperators" :key="index" :is="op.component ? op.component : 'el-button'" v-power:[op.power] v-bind="op.attrs" v-on="op.events") {{op.name}}
    common-table(
      :selectable="true"
      :isloading="isLoading"
      :headermap="headermap"
      :data="data"
      :basicdata="basicdata"
      @selection-change="selectionHandle"
      )
</template>

<script>


export default {
  name: 'ProductList',
  data() {
    return {
      searchFilters: [],
      isLoading: false,
      topOperators: null,
      headermap:[],
      data: [],
      getListFunc: null,
      basicdata: {

      },
      selection: []
    }
  },
  computed: {
    listSig() {
      return this.$store.state.listSig
    }
  },
  watch: {
    listSig() {
      this.getListData()
    },
    $route() {
      this.init()
    }
  },
  methods: {
    selectionHandle(val) {
      this.selection = val
    },
    async getListData() {
      this.isLoading = true
      if (this.getListFunc) {
        let query = {...this.$route.query}
        let res = await this.getListFunc(query)
        if (res) {
          this.data = res.items
          let { count } = res
          this.basicdata = {
            pageSize: this.$route.query.limit || 15,
            currentPage: this.$route.query.page || 1,
            total: count
          }
        }  
      }
      this.isLoading = false
    },
    
    bindTableOperator(events) {
      if(!events) return
      this.headermap.find((head) => {
        return head.key === 'op'
      }).comEvents = events
    },
    bindTopOperators(events) {
      if(!events) return
      for (let e in events) {
        let eventsComp = this.topOperators.find((op) => {
          return op.key === e
        })
        
        if(eventsComp) {
          let compEvents = events[e]
          let newEvents = {}
          for (let k in compEvents) {
            newEvents[k] = (e) => {
              return compEvents[k](e, this.selection)
            }
          }
          eventsComp.events = newEvents
        }
      }
    },
    bindGetListData(getListData) {
      this.getListFunc = getListData
    },
    init() {
      this.topOperators = []
      this.headermap = []
      this.data = []
      this.getListFunc = null

      const { headermap, tableEvents, getListData } = (this.$route.meta.viewConfig || {})
      const { topOperators, topOperatorEvents, searchFilters } = (this.$route.meta.topConfig || {})
      this.searchFilters = searchFilters || []
      this.topOperators = topOperators || []
      this.headermap = headermap || []
      this.bindTableOperator(tableEvents)
      this.bindTopOperators(topOperatorEvents)
      this.bindGetListData(getListData)
      this.getListData()
    }
  },
  mounted  () {
    this.init()
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/style/index.less';
</style>